import React, { useEffect, useMemo, useState } from 'react';

import { getFeedsKeyword } from '../../services/feeds';
import { dealwithKeyword } from '../../pages/Hero/utils';
import Tips from '../Snippets/Tips';
import KeywordItem from '../Snippets/KeywordItem';
import { LanguageType } from '../../types/common';
import { keywordLanguageMap } from '../../utils/languageValue';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';

export default function KeywordColumn({
  params,
  language,
  onClick,
  className,
  tipsClass,
  noDateText = 'No data.',
  dataReBackNotice,
  noLoading = false,
}: {
  params: any;
  language: LanguageType;
  className?: string;
  tipsClass?: string;
  noDateText?: any;
  dataReBackNotice?: any;
  noLoading?: boolean;
  onClick?: (keywordText: string, params: any) => void;
}) {
  const [keywords, setKeywords] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<null | boolean>(null);
  const [apiError, setApiError] = useState(false);

  const getFeedsKeywords = () => {
    setLoading(true);
    setApiError(false);
    getFeedsKeyword({ ...params, keyword_widely_match: true })
      .then((data: any[]) => {
        let keywordList = data || [];
        dataReBackNotice?.({ keyword: keywordList.length === 0 });
        setKeywords(keywordList);
      })
      .catch(() => {
        setKeywords([]);
        setApiError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 合并关键词
  const renderKeywordList = useMemo(() => {
    return dealwithKeyword(keywords, language);
  }, [language, keywords]);

  useEffect(() => {
    if (params.edition_unified_id) {
      getFeedsKeywords();
    }
  }, [params]);
  const { Keyword_Color } = useGetSingePageSourceRule({
    keys: ['Keyword_Color'],
  });

  return (
    <div className={className}>
      <Tips
        retryText="Loading failed, please refresh."
        loading={!noLoading && !!loading}
        apiError={apiError}
        className={tipsClass}
        style={{ color: '#888' }}
        noDateText={loading === null ? '' : noDateText}
        noData={keywords.length === 0}
      >
        {renderKeywordList?.map(
          (keyword: {
            keyword: string;
            count: any;
            keyword_en: any;
            mergedRating: any;
            sentiment_rating: any;
            mergedCount: any;
            mergedChild: any;
            child: any;
          }) => (
            <KeywordItem
              key={keyword.keyword + keyword.count + keyword.keyword_en}
              language={language}
              keyword={keyword}
              hideCount={!onClick}
              sentiment_rating={
                Keyword_Color
                  ? '3'
                  : keyword.mergedRating || keyword.sentiment_rating
              }
              count={keyword.mergedCount || keyword.count}
              itemClick={function (): void {
                let keywordList: Array<any> = [];
                let child = keyword.mergedChild || keyword.child;
                child.forEach((item: { keyword: any }) => {
                  keywordList.push(item.keyword);
                });
                onClick?.(keyword.keyword, keywordList);
              }}
              languageMap={keywordLanguageMap}
            ></KeywordItem>
          ),
        )}
      </Tips>
    </div>
  );
}
